import React, { PureComponent } from "react";
import { Button } from "react-bootstrap";
import { bootstrapUtils } from "react-bootstrap/lib/utils";
import { postRequest } from "../../api/ApiService";
import SweetAlert from "sweetalert-react";

bootstrapUtils.addStyle(Button, "light-blue");

class TeamNew extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      user_id: 0,
      team_id: 0,
      role: "",
      errorAlert: false,
      errorText: ""
    };
  }

  changeSelect = e => {
    const select = e.target;

    this.setState({
      [select.name]: select.value
    });
  };

  submit = () => {
    const { user_id, team_id, role } = this.state;
    const { game_id } = this.props;

    if (user_id > 0 && team_id > 0 && role !== "") {
      postRequest(`${process.env.REACT_APP_API_URL}games/${game_id}/join_team/`)
        .send({
          user: user_id,
          team: team_id,
          role
        })
        .then(res => {
          this.props.fetchData();
          this.setState({
            user_id: 0,
            team_id: 0,
            role: ""
          });
        })
        .catch(err => {
          if (err.response && err.response.status === 400) {
            const { user } = err.response.body;

            this.setState({
              errorAlert: true,
              errorText: user[0]
            });
          }
        });
    }
  };

  hideErrorAlert = () => {
    this.setState({
      errorAlert: false,
      errorText: ""
    });
  };

  render() {
    const { counter, free_users, teams } = this.props;
    const { user_id, team_id, role, errorAlert, errorText } = this.state;

    return (
      <tr>
        <td className="text-center v-align-middle instructor-round-number b-r">
          {counter}
        </td>
        <td className="b-l b-r v-align-middle instructor-td text-center">
          <select name="user_id" value={user_id} onChange={this.changeSelect}>
            <option value="0">Select user</option>
            {free_users.map((user, index) => (
              <option key={index} value={user.id}>
                {user.username}
              </option>
            ))}
          </select>
        </td>
        <td className="b-l b-r v-align-middle instructor-td">
          <select name="team_id" value={team_id} onChange={this.changeSelect}>
            <option value="0">Select team</option>
            {teams.map((team, index) => (
              <option key={index} value={team.id}>
                {team.name}
              </option>
            ))}
          </select>
        </td>
        <td className="b-l b-r v-align-middle instructor-td">
          <select name="role" value={role} onChange={this.changeSelect}>
            <option value="">Select role</option>
            <option value="CEO">CEO</option>
            <option value="PD">Head of Product Development</option>
            <option value="PM">Head of Product Marketing</option>
            <option value="OP">Head of Operations</option>
            <option value="FI">Head of Finance</option>
          </select>
        </td>
        <td className="b-l">
          <Button bsStyle="light-blue" onClick={this.submit} block>
            Add
          </Button>
          <SweetAlert
            show={errorAlert}
            title="Error"
            text={errorText}
            type="error"
            onConfirm={this.hideErrorAlert}
          />
        </td>
      </tr>
    );
  }
}

export default TeamNew;



// WEBPACK FOOTER //
// ./src/instructor/components/team-new.js